exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-3e8104d9] tbody td{\n    cursor: pointer;\n}\n[data-v-3e8104d9] tbody td td.non-clickable{\n    cursor: auto;\n}\n.brandTag[data-v-3e8104d9]{\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n", ""]);

// exports
